import { render, staticRenderFns } from "./ClientGroups.vue?vue&type=template&id=d41ac0f8&scoped=true&"
import script from "./ClientGroups.vue?vue&type=script&lang=js&"
export * from "./ClientGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41ac0f8",
  null
  
)

export default component.exports